import { createAction } from '@reduxjs/toolkit';

export const fetchExportV4ApiKey = createAction('generalSettings/fetchExportV4ApiKey');

export const getAccessTokens = createAction<string>('generalSettings/getAccessTokens');
